const OpenEye = ({ className, stroke = 'white' }) => (
  <svg
    className={className}
    width='27'
    height='24'
    viewBox='0 0 27 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <g>
        <path
          id='Path'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.54934 14.998C3.35074 14.693 3.35074 14.307 3.54934 14.002C5.63963 10.779 9.45811 8 13.2766 8C17.0951 8 20.9125 10.779 23.0027 14.001C23.2013 14.307 23.2013 14.694 23.0027 15C20.9125 18.221 17.0951 21 13.2766 21C9.45811 21 5.63963 18.221 3.54934 14.998Z'
          stroke={stroke}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Path_2'
          d='M15.6038 12.379C16.8898 13.551 16.8898 15.45 15.6038 16.622C14.3178 17.794 12.2341 17.794 10.9481 16.622C9.66214 15.45 9.66214 13.551 10.9481 12.379C12.2341 11.207 14.3189 11.207 15.6038 12.379'
          stroke={stroke}
          strokeWidth='1.4286'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Path_3'
          d='M13.2767 2.5V5'
          stroke={stroke}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Path_4'
          d='M5.5957 4.5L7.43911 6.5'
          stroke={stroke}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Path_5'
          d='M20.9574 4.5L19.114 6.5'
          stroke={stroke}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </g>
  </svg>
)

export default OpenEye
